var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"nav flexJA"},[_c('div',{on:{"click":function($event){return _vm.jumpToPage()}}},[_c('img',{attrs:{"src":require("@/assets/images/21.png"),"alt":""}})]),_c('div',{staticClass:"title banLine",domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }